import React, { useState } from "react";
import {Tag} from "primereact/tag";

import { OrderDto } from "../../domain";
import { DateUtils } from "../../../../../helpers/date";
import { BulkResponse } from "../../data";
import { PrimeIcons } from "primereact/api";
import { tawreedTranslationService } from "../../../../../common/translations";
import { GlobalContext } from "../../../../../context";

export type OrderDetailsTemplateProps = {
    /**
     *
     */
    rowData: OrderDto;

    response?: BulkResponse;
}

export const OrderDetailsTemplate: React.FC<OrderDetailsTemplateProps> = (props) => {
    
        const { auth: { user } } = React.useContext(GlobalContext);
    return (
        <div className="grid">
             <div className="col-12">
             <div className="flex">
                <span className="mr-auto">
                
                </span>
                {
                    props.response &&
                    <Tag severity={props.response.success ? 'success' : 'danger'}
                    //  style={{maxWidth: '10rem'}}
                     icon={props.response.success ? PrimeIcons.CHECK : PrimeIcons.TIMES}
                     value={props.response.reason}/>
                }
                
                
            </div>
             </div>
        <div className="col-6">
            <div>
            <span>{tawreedTranslationService.translate("lbl_sales_orders_header_order_id")}: </span>
                {props.rowData.orderId}
                <br/>
                {(user!.roleCode !== 'STORE_ADMIN' && user!.roleCode !== 'STORE_REVIEWER') &&
                    <React.Fragment>
                    <span>{tawreedTranslationService.translate("lbl_sales_orders_store")}: </span>
                    {props.rowData.store?.partnerName}
                    <br/>
                    </React.Fragment>
                }
                <span>{tawreedTranslationService.translate("lbl_sales_orders_header_pricelistid")}: </span>
                {props.rowData.priceListItem?.name}
                <br/>
            </div>
        </div>
        
        <div className="col-6">
            {/* <div className="flex">
                <span className="mr-auto">
                
                </span>
                {
                    props.response &&
                    <Tag severity={props.response.success ? 'success' : 'danger'}
                     style={{maxWidth: '10rem'}}
                     icon={props.response.success ? PrimeIcons.CHECK : PrimeIcons.TIMES}
                     value={props.response.reason}/>
                }
                
                
            </div> */}
            <div>
            <span>{tawreedTranslationService.translate("lbl_sales_orders_date")}: </span>
                {DateUtils.format(props.rowData.orderDate!, 'datetime')}
                <br/>
                
                <span>{tawreedTranslationService.translate("lbl_sales_orders_status")}: </span>
                {props.rowData.status!}
                <br/>
                <span>{tawreedTranslationService.translate("lbl_sales_orders_paymentmodeid")}: </span>
                {props.rowData.paymentModeName}
                <br/>
            </div>
        </div>
        </div>
    );
}
